import { isEditorJsDocument, isTinymceHtmlDocument } from "./compat";
import { RichTextDocument } from "./types";

export const getParsedDataForJsonStringField = (
  data: RichTextDocument | string | null | undefined,
): string | null => {
  if (!data) {
    return null;
  }

  if (typeof data === "string") {
    return data.trim() ? data : null;
  }

  if (isTinymceHtmlDocument(data)) {
    return data.html.trim() ? JSON.stringify(data) : null;
  }

  if (isEditorJsDocument(data)) {
    return data.blocks.length ? JSON.stringify(data) : null;
  }

  return null;
};
